<template>
  <div class="layout_contents">
    <!-- Title -->
    <div class="area_title">
      <div class="txt_title">{{ $t('facilityGuide.cabinLocation') }}</div>
      <div class="txt_det">{{ $t('facilityGuide.dreamIntro') }}</div>
    </div>
    <!-- //Title -->

    <div class="area_contents">
      <!-- Swiper -->
      <swiper
        class="tabs_slider"
        :modules="modules"
        :slidesPerView="'auto'"
        :space-between="12"
        navigation
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(room, index) in dreamRoomList" :key="index">
          <a href="javascript:" :class="{ active: currentTab === index }" @click="currentTab = index">
            {{ room.name[locale] }}
          </a>
        </swiper-slide>
      </swiper>
      <!-- //Swiper -->

      <div>
        <!-- View Room -->
        <div class="view_room">
          <!-- info Room -->
          <div class="info_room">
            <div class="info_room_content">
              <div class="data_view">{{ dreamRoomList[currentTab].category }}</div>
              <div class="name_room">{{ dreamRoomList[currentTab].name[locale] }}</div>
              <div class="room_desc">{{ dreamRoomList[currentTab].promotionalText[locale] }}</div>
              <div class="room_desc sub" v-if="dreamRoomList[currentTab].promotionalSubText">
                {{ dreamRoomList[currentTab].promotionalSubText[locale] }}
              </div>

              <ul class="list_info">
                <li v-for="item in convertDescription">{{ item }}</li>
              </ul>
            </div>

            <div class="detail_image_list">
              <swiper
                class="tab_menu"
                :modules="modules"
                :slidesPerView="3"
                navigation
                @swiper="onSwiper"
                @slideChange="onSlideChange"
              >
                <swiper-slide
                  v-for="(item, index) in detailsImageBodyList[currentTab]"
                  :key="index"
                  :class="{ active: imageActiveTab[currentTab] === index }"
                >
                  <a href="javascript:" @click="imageActiveTab[currentTab] = index">
                    <img :src="item.url" />
                  </a>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <!-- //info Room -->

          <div class="tab_content">
            <img :src="selectedImageUrl" />
          </div>
        </div>
        <!-- //View Room -->
        <!-- Location -->
        <div class="view_location" v-if="currentLocationImageUrl">
          <div class="label_location">{{ $t('facilityGuide.location') }}</div>
          <div class="local_image">
            <img :src="currentLocationImageUrl" />
          </div>
        </div>
        <!-- //Location -->
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/navigation';
import 'swiper/css';

export default {
  name: 'DreamRoom',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      currentTab: 0,
      imageActiveTab: [],
      dreamRoomList: [
        {
          category: 'OCEAN VIEW',
          name: {
            ko: '로얄 스위트',
            en: 'Royal Suite',
            ja: 'ロイヤルスイート',
          },
          promotionalText: {
            ko: 'VIP만을 위한 특별한 공간',
            en: 'Exclusive space for VIPs',
            ja: 'VIPのための特別な空間',
          },
          description: {
            ko: '샤워실, 화장실, 생수 및 음료, 커피, 차 제공\n2인 기준 객실\n바다 전망\n시설 위치: 2F A-DECK',
            en: 'Shower Booth, Toilet, Water and Beverages\nRoom for 2 persons\nOcean View\nFacility Location : 2F A-DECK',
            ja: 'シャワー室、ミネラルウォーター・飲み物\n2人基準客室\n海の眺め\n施設の位置：2F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_royal_room01.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_royal_location.png'),
            },
          ],
        },
        {
          category: 'OCEAN VIEW',
          name: {
            ko: '디럭스 스위트',
            en: 'Deluxe Suite',
            ja: 'デラックススイート',
          },
          promotionalText: {
            ko: '가족과 연인 등의 소그룹을 위한 고품격 공간',
            en: 'Premium space for small groups like families and couples',
            ja: 'VIPのための特別な空間',
          },
          description: {
            ko: '샤워실, 화장실, 생수 및 음료, 커피, 차 제공\n2인 기준 객실\n바다 전망\n시설 위치: 2F A-DECK',
            en: 'Shower Booth, Toilet, Water and Beverages\nRoom for 2 persons\nOcean View\nFacility Location : 2F A-DECK',
            ja: 'シャワー室、ミネラルウォーター・飲み物\n2人基準客室\n海の眺め\n施設の位置：2F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_deluxe_room01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_deluxe_room02.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_deluxe_location.png'),
            },
          ],
        },
        {
          category: 'OCEAN VIEW',
          name: {
            ko: '패밀리 룸',
            en: 'Family Room',
            ja: 'ファミリールーム',
          },
          promotionalText: {
            ko: '가족이나 소규모 그룹을 위한 단아한 공간',
            en: 'Elegant space for families or small groups',
            ja: '家族や小規模グループのための落ち着いた空間',
          },
          description: {
            ko: '샤워실, 화장실\n4인 기준 객실\n바다 전망\n시설 위치: 1F A-DECK',
            en: 'Shower Booth, Toilet\nRoom for 4 persons\nOcean View\nFacility Location : 1F A-DECK',
            ja: 'シャワー室、トイレ\n4人基準客室\n海の眺め\n施設の位置：1F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_family_room01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_family_room02.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_family_location.png'),
            },
          ],
        },
        {
          category: 'INSIDE',
          name: {
            ko: '스탠다드룸 A',
            en: 'Standard Room A',
            ja: 'スタンダード4人室',
          },
          promotionalText: {
            ko: '중소그룹 고객을 위한 휴식 공간',
            en: 'Relaxation space for small and medium groups',
            ja: '中小グループのお客様のための休憩空間',
          },
          description: {
            ko: '세면대\n4인, 8인 기준 객실\n복도측\n시설 위치: 2F A-DECK',
            en: 'Sink\nRoom for 4, 8 persons\nCorridors\nFacility Location : 2F A-DECK',
            ja: '洗面台\n4人基準客室\n廊下側\n施設の位置：2F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_standard_room01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_standard_room02.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_standard_location.png'),
            },
          ],
        },
        {
          category: 'INSIDE',
          name: {
            ko: '스탠다드룸 A 콤비',
            en: 'Standard Room A - Combi',
            ja: 'スタンダード6人室',
          },
          promotionalText: {
            ko: '중소그룹 고객을 위한 휴식 공간',
            en: 'Relaxation space for small and medium groups',
            ja: '中小グループのお客様のための休憩空間',
          },
          description: {
            ko: '세면대\n8인 기준 객실\n복도측\n시설 위치: 2F A-DECK',
            en: 'Sink\nRoom for 8 persons\nCorridors\nFacility Location : 2F A-DECK',
            ja: '洗面台\n6人基準客室\n廊下側\n施設の位置：2F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_combi_room01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_combi_room02.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_combi_room03.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_combi_location.png'),
            },
          ],
        },
        {
          category: 'INSIDE',
          name: {
            ko: '스탠다드룸 트윈베드',
            en: 'Standard Room - Twin Bed',
            ja: 'スタンダード2人室／ツインベッド2台',
          },
          promotionalText: {
            ko: '개인고객이나 소규모 그룹, 대형 그룹까지 활용도 높은 일반형 공간',
            en: 'A general space that can be easily utilized by individual customers, small groups, and large groups',
            ja: '個人客や小グループ、大グループまで多目的に使える一般形空間',
          },
          description: {
            ko: '스탠다드 트윈베드\n2인 기준 객실\n복도측\n시설 위치: 1F A-DECK',
            en: 'Standard twin bed\nRoom for 2 persons\nCorridors\nFacility Location : 1F A-DECK',
            ja: 'スタンダードツインベッド\n2人基準客室\n廊下側\n施設の位置：1F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_twin_room01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_twin_room02.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_twin_location.png'),
            },
          ],
        },
        {
          category: 'INSIDE',
          name: {
            ko: '스탠다드룸 벙커베드',
            en: 'Standard Room - Bunk Bed',
            ja: 'スタンダード2人室／2段ベッド',
          },
          promotionalText: {
            ko: '개인고객이나 소규모 그룹, 대형 그룹까지 활용도 높은 일반형 공간',
            en: 'A general space that can be easily utilized by individual customers, small groups, and large groups',
            ja: '個人客や小グループ、大グループまで多目的に使える一般形空間',
          },
          description: {
            ko: '2층 침대 1~2개\n2~4인 기준 객실\n시설 위치: 1F A-DECK',
            en: '2-Story bed 1-2 unit\nRoom for 2-4 persons\nFacility Location : 1F A-DECK',
            ja: '二段ベッド1〜2個\n2〜4人基準客室\n施設の位置：1F A-DECK',
          },
          gradeImages: [
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_bunker_room01.png'),
            },
            {
              category: 'details',
              url: require('@/assets/images/information/facility/dream_bunker_room02.png'),
            },
            {
              category: 'location',
              url: require('@/assets/images/information/facility/dream_bunker_location.png'),
            },
          ],
        },
      ],

      detailsImageBodyList: [],
      locationImageBodyList: [],
    };
  },
  watch: {
    currentTab() {
      this.imageActiveTab[this.currentTab] = 0;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    selectedImageUrl() {
      return this.detailsImageBodyList[this.currentTab]?.[this.imageActiveTab[this.currentTab]]?.url || '';
    },
    currentLocationImageUrl() {
      return this.locationImageBodyList[this.currentTab]?.url || '';
    },
    convertDescription() {
      return this.dreamRoomList[this.currentTab].description[this.locale].split('\n');
    },
  },
  methods: {
    showTabContent(imageSrc) {
      this.selectedTabImageSrc = imageSrc;
    },
    getDreamRoomList() {
      // TODO: API 연동
      this.detailsImageBodyList = this.dreamRoomList.map(item =>
        item.gradeImages.filter(image => image.category === 'details'),
      );
      this.locationImageBodyList = this.dreamRoomList.map(item =>
        item.gradeImages.find(image => image.category === 'location'),
      );

      this.imageActiveTab = Array(this.dreamRoomList.length).fill(0);
    },
  },
  setup() {
    const onSwiper = () => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation],
    };
  },
  created() {
    this.getDreamRoomList();
  },
};
</script>

<style scoped>
.tabs_slider {
  padding: 6px 0;
  margin-bottom: 60px;
}
.tabs_slider .swiper-slide {
  width: auto !important;
  margin-right: 12px;
}
.tabs_slider .swiper-slide a {
  display: inline-block;
  padding: 0 28px;
  border-radius: 100px;
  border: 1px solid #446ceb;
  font-weight: 600;
  color: #446ceb;
  font-size: 20px;
  line-height: 54px;
  background-color: #fff;
}
.tabs_slider .swiper-slide a.active {
  background-color: #446ceb;
  color: #fff;
}
.tabs_slider :deep(.swiper-button-prev),
.tabs_slider :deep(.swiper-button-next) {
  width: 70px;
  height: 62px;
  top: 4px;
  margin: 0;
  background-color: #fff;
}
.tabs_slider :deep(.swiper-button-prev) {
  left: 0;
}
.tabs_slider :deep(.swiper-button-next) {
  right: 0;
}

.tabs_slider :deep(.swiper-button-prev:before),
.tabs_slider :deep(.swiper-button-next:before) {
  position: absolute;
  top: 1px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  content: '';
  flex: none;
}
.tabs_slider :deep(.swiper-button-prev:before) {
  left: 5px;
}
.tabs_slider :deep(.swiper-button-next:before) {
  right: 5px;
}
.tabs_slider :deep(.swiper-button-prev.swiper-button-disabled),
.tabs_slider :deep(.swiper-button-next.swiper-button-disabled) {
  display: none;
}
.tabs_slider :deep(.swiper-wrapper) {
  height: 56px;
}
.tabs_slider :deep(.swiper-button-prev:after),
.tabs_slider :deep(.swiper-button-next:after) {
  color: #b6bbbf;
  font-weight: bold;
  font-size: 20px;
  z-index: 1;
}
.tabs_slider :deep(.swiper-button-prev:after) {
  margin-left: -2px;
}
.tabs_slider :deep(.swiper-button-next:after) {
  margin-right: -2px;
}
.tabs_slider :deep(.swiper-wrapper) {
  height: auto;
  padding: 2px 2px;
  margin: 0 -2px;
}

.view_room {
  display: flex;
  gap: 20px;
}
.view_room .info_room {
  width: 482px;
  height: 439px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
}
.view_room .info_room .data_view {
  color: #9299a0;
  font-size: 19px;
  line-height: 24px;
  margin-bottom: 4px;
}
.view_room .info_room .name_room {
  color: var(--Blue-blue-700, #304da7);
  font-size: 28px;
  font-weight: 600;
  line-height: 24px; /* 85.714% */
  letter-spacing: -1.5px;
  margin-bottom: 24px;
}
.view_room .info_room .room_desc {
  color: var(--Grey-grey-800, #505458);
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
}
.view_room .info_room .room_desc.sub {
  font-weight: 400;
}
.view_room .info_room .list_info {
  margin-top: 28px;
}
.view_room .info_room .list_info li {
  color: var(--Grey-grey-700, #686d72);
  display: flex;
  align-items: flex-start;
  font-size: 20px;
  line-height: 180%;
  letter-spacing: -0.4px;
}
.view_room .info_room .list_info li:before {
  position: relative;
  top: 2px;
  margin: 13px;
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #b6bbbf;
  content: '';
}
.detail_image_list {
  position: relative;
  width: 420px;
  height: 90px;
}
.view_room .tab_menu {
  position: static;
  border-radius: 7px;
  width: 100%;
  height: 100%;
  margin: 0;
}
.view_room .tab_menu .swiper-slide {
  opacity: 0.6;
  width: 140px;
  height: 100%;
}
.view_room .tab_menu .swiper-slide.active {
  opacity: 1;
}
.view_room .tab_menu .swiper-slide a img {
  width: 140px;
  height: 100%;
}
.view_room .tab_menu .swiper-slide:last-child a img {
  border-radius: 0 7px 7px 0;
}
.view_room .tab_menu .swiper-slide a {
  display: block;
  width: 100%;
  height: 100%;
}
.view_room .tab_menu :deep(.swiper-button-prev),
.view_room .tab_menu :deep(.swiper-button-next) {
  width: 30px;
  height: 30px;
  transform: translateY(-50%);
  margin: 0;
}
.view_room .tab_menu :deep(.swiper-button-prev) {
  left: -15px;
}
.view_room .tab_menu :deep(.swiper-button-next) {
  right: -15px;
}
.view_room .tab_menu :deep(.swiper-button-prev:before),
.view_room .tab_menu :deep(.swiper-button-next:before) {
  position: absolute;
  top: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  content: '';
  flex: none;
}
.view_room .tab_menu :deep(.swiper-button-prev:before) {
  left: 0;
}
.view_room .tab_menu :deep(.swiper-button-next:before) {
  right: 5px;
  right: 0;
}
.view_room .tab_menu :deep(.swiper-button-prev.swiper-button-disabled),
.view_room .tab_menu :deep(.swiper-button-next.swiper-button-disabled) {
  display: none;
}
.view_room .tab_menu :deep(.swiper-button-prev:after),
.view_room .tab_menu :deep(.swiper-button-next:after) {
  color: #b6bbbf;
  font-weight: bold;
  font-size: 10px;
  z-index: 1;
}
.view_room .tab_menu :deep(.swiper-button-prev:after) {
  margin-left: -2px;
}
.view_room .tab_menu :deep(.swiper-button-next:after) {
  margin-right: -2px;
}
.view_room .tab_content {
  flex: auto;
  height: 439px;
  overflow: hidden;
  border-radius: 16px;
}
.view_location {
  margin: 60px 0 0 0;
}
.view_location .local_image {
  overflow: auto;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  width: 100%;
}
.view_location .label_location {
  margin-bottom: 24px;
  color: #505458;
  font-weight: 600;
  line-height: 24px;
  font-size: 22px;
}

@media (max-width: 767px) {
  .view_room .tab_content {
    height: 234px;
    border-radius: 5px;
  }
  .view_room {
    flex-direction: column;
    margin-top: 24px;
  }
  .view_room .info_room {
    width: 100%;
    height: auto;
    gap: 16px;
  }
  .view_room .info_room .name_room {
    font-size: 22px;
    margin-bottom: 16px;
  }
  .view_room .info_room .room_desc {
    font-size: 18px;
  }
  .view_room .info_room .list_info {
    margin-bottom: 8px;
  }
  .view_room .info_room .list_info li {
    font-size: 16px;
    line-height: 140%; /* 22.4px */
    letter-spacing: -0.32px;
  }
  .view_room .info_room .list_info li:before {
    margin-top: 6px;
  }
  .view_room .info_room .list_info li + li {
    margin-top: 8px;
  }
  .detail_image_list {
    width: 100%;
    height: auto;
    min-height: 70px;
  }
  .view_room .tab_menu {
    width: unset;
  }
  .view_room .tab_menu .swiper-slide {
    width: 33.333333% !important;
    height: unset;
  }
  .view_room .tab_menu .swiper-slide a img {
    width: 100%;
    height: 100%;
  }
  .view_room .tab_menu :deep(.swiper-button-prev),
  .view_room .tab_menu :deep(.swiper-button-next) {
    display: none;
  }
  .view_location {
    margin: 20px 0 0 0;
  }
  .view_location .local_image img {
    width: auto;
    height: 190px;
  }
  .view_location .label_location {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 24px;
  }
  .tabs_slider {
    margin-bottom: 24px;
  }
  .tabs_slider :deep(.swiper-wrapper) {
    height: 41px;
  }
  .tabs_slider :deep(.swiper-button-next),
  .tabs_slider :deep(.swiper-button-prev) {
    display: none !important;
  }

  .tabs_slider .swiper-slide {
    margin-right: 8px;
  }
  .tabs_slider .swiper-slide a {
    font-size: 14px;
    padding: 0 12px;
    line-height: 39px;
  }
  .view_room .info_room .list_info .txt_info {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
